import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { usersApi } from "api";
import { Loading } from "components/StatusScreen";
import { clearUserCookie } from "lib/userCookie";
import { signedOut } from "store/actions/users";

// /logout (also linked from the public site's account menu): the API ends
// the session and clears its cookie.
export default function Logout({ history }) {
  const dispatch = useDispatch();
  useEffect(() => {
    usersApi
      .logout()
      .catch(() => {})
      .finally(() => {
        clearUserCookie();
        dispatch(signedOut());
        history.replace("/login");
      });
  }, [dispatch, history]);
  return <Loading />;
}
